import { Divider, Stack, useTheme } from "@mui/material";
import type { FC } from "react";

export const SectionDivider: FC = () => {
	const theme = useTheme();

	return (
		<Stack py={1.2}>
			<Divider sx={{ borderColor: theme.palette.grey[100] }} />
		</Stack>
	);
};
